export const responsiveSizes = {
    xs: 0, // 0 - 576
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    voucherImageChange: 740,
};

export const secondaryColor = "pink";
export const primaryColor = "teal";
export const secondaryColorHex = "#e03997";
export const primaryColorHex = "#009c95";

export const PIN_PAYMENTS_HOSTED_URL = "https://pay.pinpayments.com/s52n/sc";
